/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
 var variant = event.detail.variant; 
 console.log("variant data",event.detail);
 if(variant){
   $(".proVarId_"+variant.id).show();
   $(".proVarId_"+variant.id).siblings().hide();   
   if(!variant.compare_at_price){
     $(".product-block-list .product-label--on-sale").hide();
   }else{
     $(".product-block-list .product-label--on-sale").show();
   }    
   let discount = parseInt(((parseInt(variant.compare_at_price) - parseInt(variant.price))*100)/parseInt(variant.compare_at_price));
   console.log(discount);
   $(".gcs-save-label").text(`SAVE ${discount}%`);
 }else{
   $(".gcs-save-label").text(``);
 }
});

$(document).ready(function() {
  window.onclick = function(e) {
    if (e.target.className ==="modal_PDP" || e.target.className ==="close" ) {
      $(".modal_PDP").hide();
    }
  }
});


let delivery_date,delivery_time,extra_added_entity;

$(document).on("click", ".date_grid_box", function () {
    $(this).addClass("active")
        .closest('.grid')
        .find('.date_grid_box')
        .not(this)
        .removeClass("active");

    if ($(this).attr('data-date')) {
        delivery_date = $(this).attr('data-date');
        $("#order_delivery_date").val(delivery_date);
    } else if ($(this).attr('data-time')) {
        delivery_time = $(this).attr('data-time');
        $("#order_delivery_time").val(delivery_time);
    }
});



$(".ribbon_grid_box").click(function(){
    $(this).addClass("active");
    $(this).parents(".grid").find('.ribbon_grid_box').removeClass("active");
    $(this).addClass("active");

})

function addThisProd(obj,id){
  if(id !== null){
    let url = `https://${window.location.host}/cart/add.js`;
    let properties = {'Delivery_Date':delivery_date,'Delivery_Time':delivery_time,'Product':'Gift'}
    $.ajax({
        type: 'POST',
        url,
        data: { quantity: 1,id,properties },
        dataType: 'json', 
        success: function (data) { 
          console.log(data);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true 
          }));
        } 
    });
  }
}
function addGoldMember(obj,id){
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  if(id !== null){
    let url = `https://${window.location.host}/cart/add.js`;
    let properties = {'Product':'Gold Membership'}
    $.ajax({
        type: 'POST',
        url,
        data: { quantity: 1,id,properties },
        dataType: 'json', 
        success: function (data) { 
          console.log(data);
          $(".modal_PDP").hide();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true 
          }));
          $(".header__cart-icon").trigger('click');
          window.scrollTo({top: 0,behavior: 'smooth'});
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        } 
    });
  }
}
$(".value-picker-button").click(function(){
  $("#account-selector").attr("aria-hidden","false");
  $(this).attr("aria-expanded","true");
});
$(".value-picker__close").click(function(){
  $("#account-selector").attr("aria-hidden","true");
  $(".value-picker-button").attr("aria-expanded","false");
});



$(".container.blog-posts-slider.block-list.block-list--loose").slick({
dots: false,
infinite: false,
speed: 300,
slidesToShow: 3,
slidesToScroll: 3,
responsive: [
{
breakpoint: 1024,
settings: {
slidesToShow: 3,
slidesToScroll: 3,
infinite: true

}
},
{
breakpoint: 800,
settings: {
slidesToShow: 2,
dots: true,
slidesToScroll: 2
}
},
{
breakpoint: 480,
settings: {
slidesToShow: 1,
dots: true,
slidesToScroll: 1

}
}
]
});




if ($(window).width() < 767) {
$(".Our_top_Categorys .collection-listH").slick({
   rows: 2,
   slidesToShow: 3,
   infinite:true,
   slidesToScroll: 3,
   dots: true,
   arrows:false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
  });


$(".Our_Brands .grid").slick({
   rows: 2,
   slidesToShow: 3,
   infinite:true,
   slidesToScroll: 3,
   dots: true,
   arrows:false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
  });

}